<template>
    <ApplicationTableCustomField
        fieldType="beneficiary"
        :items="items"
    />
</template>

<script>
import ApplicationTableCustomField from '@/modules/applications/components/ApplicationTableCustomField';
export default {
    name: 'BeneficiaryCustomField',
    components: { ApplicationTableCustomField },
    props: {
        dataObj: {
            type: Object,
        }
    },
    computed: {
        items() {
            return this.dataObj.item.form?.beneficiary_users ?? [];
        }
    }
};
</script>
